import { api } from '@wellesley/openapi'
import { handleBasicResponse } from '@wellesley/openapi/helpers'

const joinRequestsApi = api.enhanceEndpoints({
  endpoints: {
    getApiV1GroupsByGroupIdJoinRequests: {
      providesTags: ['Group_Join_Requests', 'USER_CHANGED'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    putApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestId: {
      invalidatesTags: ['Group_Join_Requests'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    deleteApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestId: {
      invalidatesTags: ['Group_Join_Requests'],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
  },
})

export const {
  useGetApiV1GroupsByGroupIdJoinRequestsQuery,
  usePutApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdMutation,
  useDeleteApiV1GroupsByGroupIdJoinRequestsAndGroupJoinRequestIdMutation,
} = joinRequestsApi
